import React from 'react'
import { Paper, Popper } from '@mui/material'

const PopperContainer = ({open, anchorEl, children, width}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={width ? 'bottom-start' : 'bottom'}
      sx={{
        zIndex: 10000000,
        boxSizing: 'border-box',
        borderTopLeftRadius: '0 !important',
        borderTopRightRadius: '0 !important',
      }}
    >
      <Paper
        sx={{
          ...(width ? { width } : { minWidth: `${anchorEl?.clientWidth}px` ?? '500px' }),
          mt: '0'
        }}
      >
        {children}
      </Paper>
    </Popper>
  )
}

export default PopperContainer
